import { BaseSettings} from 'Shared/frontend/themes/BaseSettings';
import { INav } from 'Common/config/INav';
import { Contact } from 'Shared/frontend/icons/Contact';
import {Calendar} from 'Shared/frontend/icons/Calendar';
import {FoodMenu} from 'Shared/frontend/icons/FoodMenu';
import {Home} from 'Shared/frontend/icons/Home';
import {PeopleCircle} from 'Shared/frontend/icons/PeopleCircle'; 
import {PeopleCircle as BackendPeopleCircle} from 'Shared/backend/icons/PeopleCircle'; 


export class FamilySettings extends BaseSettings
{
	pages()
	{
		return [
			{
				key: 'home',
				frontend: {
					route: '/',
					metaTitle: 'Home'
				},
				backend: {
					route: '/home',
					title: 'Home'
				}
			},
			{
				key: 'events',
				frontend: {
					route: '/events',
					metaTitle: 'Events'
				},
				backend: {
					route: '/events-design',
					title: 'Events'
				}
			},
			{
				key: 'dine',
				frontend: {
					route: '/dine',
					metaTitle: 'Dine'
				},
				backend: {
					route: '/dine',
					title: 'Dine'
				}
			},
			{
				key: 'hire',
				frontend: {
					route: '/hire',
					metaTitle: 'Hire'
				},
				backend: {
					route: '/hire',
					title: 'Hire'
				}
			},
			{
				key: 'contact',
				frontend: {
					route: '/contact',
					metaTitle: 'Contact'
				},
				backend: {
					route: '/contact',
					title: 'Contact'
				}
			},
			{
				key: 'stay',
				frontend: {
					route: '/stay',
					metaTitle: 'Stay'
				},
				backend: {
					route: '/stay',
					title: 'Stay'
				}
			},
			{
				key: 'vouchers',
				frontend: {
					route: '/vouchers',
					metaTitle: 'Vouchers'
				},
				backend: {
					route: '/vouchers',
					title: 'Vouchers'
				}
			},
			
		];
	}

	navContent(): INav
	{
		return {
			desktop: [
				{label:'Home',		link:'frontend/Home'},
				{label:'Menus',		link:'frontend/Menu'},
				{label:'Events',	link:'frontend/Events'},
				{label:'Dine',		page:'dine'},
				{label:'Contact',	link:'frontend/Contact'},

				{label:'More',	items: [ 
					{label:'Hire',		link:'frontend/Hire'},
					{label:'Stay',		page:'stay'},
					{label:'Vouchers',	page:'vouchers'},
				]},
			],
			mobile: {
				maxButtons: 5,
				includeMoreButton: true,
				links: [
					{label:'Home',		link:'frontend/Home',		icon:Home},
					{label:'Menus',		link:'frontend/Menu',		icon:FoodMenu},
					{label:'Events',	link:'frontend/Events',		icon:Calendar},
					{label:'Dine',		page:'dine',				icon:PeopleCircle},
					{label:'Contact',	link:'frontend/Contact',	icon:Contact},
					{label:'Hire',		link:'frontend/Hire', 		icon:Contact},
					{label:'Stay',		page:'stay',				icon:Contact},
					{label:'Vouchers',	page:'vouchers',			icon:Home},
				]
			}
		};
	}

	backendNavContent()
	{
		return [
			...super.backendNavContent(),
			{label:'Staff',		route:'/admin/staffResources',	icon:BackendPeopleCircle},
		];
	}

}
